import React, { useContext } from 'react'
import { FiHelpCircle } from 'react-icons/fi'
import { useField, useFormikContext } from 'formik'
import { FaQuestionCircle } from 'react-icons/fa'
import { twMerge } from 'tailwind-merge'

import Option from './Option'

import { TipContainer } from '../styles'
import { Select, SelectContainer } from './styles'
import { TipContext } from '../../../contexts/TipContext'

const selectStyle = {
    input: (styles) => ({
        ...styles,
        color: '#424242'
    }),
    control: (styles, { isDisabled }) => ({
        ...styles,
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        border: 0,
        boxShadow: 'none',
        height: 44,
        cursor: 'pointer',
        opacity: isDisabled ? 0.8 : 1,
        ':focus-within': {
            border: 'dashed 1px rgba(255, 255, 255, 0.9)'
        }
    }),
    singleValue: (styles) => ({
        ...styles,
        color: '#424242'
    }),
    multiValue: (styles) => ({
        ...styles,
        backgroundColor: '#FFF',
        borderRadius: 15,
        color: '#424242',
        padding: '4px 0'
    }),
    multiValueRemove: (styles) => ({
        ...styles,
        '&:hover': {
            backgroundColor: 'transparent'
        }
    }),
    clearIndicator: () => ({
        display: 'none'
    }),
    placeholder: (styles) => ({
        ...styles,
        color: '#acacac'
    }),
    menuPortal: provided => ({ ...provided, zIndex: 9 })
}

export default function ({
    withoutForm,
    label,
    placeholder = 'Selecione...',
    options,
    style = {},
    containerStyle = {},
    isDisabled,
    containerClass = '',
    className = '',
    hint,
    ...props
}) {
    let field
    let meta
    let helpers

    if (!withoutForm) {
        [field, meta, helpers] = useField(props)
    }

    const { tips, handleSpeak } = useContext(TipContext)
    const formik = useFormikContext()

    const tip = tips.campos?.find(item => item.campo === field?.name || item.campo === props.id || props.name === item.campo || props.id === item.campo)
    const tipText = tip?.texto
    const tipAvatarText = tip?.texto_avatar

    const screenWidth = window.innerWidth

    if (withoutForm) {
        return (
            <SelectContainer className={containerClass} style={containerStyle}>
                <span className="label text-slate-800">{label}</span>

                {screenWidth <= 440 ? (
                    <select
                        style={{
                            boxShadow: 'rgba(0, 0, 0, 0.14) 0px 4px 5px 0px, rgba(0, 0, 0, 0.12) 0px 1px 10px 0px, rgba(0, 0, 0, 0.3) 0px 2px 4px -1px',
                            ...style
                        }}
                        className={twMerge('h-11 rounded-sm cursor-pointer text-slate-800', className)}
                        disabled={isDisabled || !options?.length}
                        {...props}
                        value={props.value?.value}
                        onChange={e => {
                            const selectedOption = options.find(item => item.value == e.target.value)

                            props.onChange(selectedOption)
                        }}
                    >   
                        <option value="">Selecione...</option>

                        {options.map(option => (
                            <option value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                ) : (
                    <Select
                        options={options}
                        className={`select ${className || ''}`}
                        noOptionsMessage={() => 'Nenhuma opção disponível'}
                        menuPortalTarget={document.querySelector('body')}
                        components={{
                            Option,
                            IndicatorSeparator: null,
                            DropdownIndicator: null // Chevron 
                        }}
                        styles={selectStyle}
                        style={style}
                        isDisabled={isDisabled || !options?.length}
                        placeholder={placeholder}
                        {...props}
                    />
                )}

                {hint && <div className={`hint ${hint.type}`} dangerouslySetInnerHTML={{ __html: hint.text }} />}

                {tipText ? (
                    <>
                        <FiHelpCircle size={14} />

                        <TipContainer>
                            <FaQuestionCircle size={13} />
                            <span>{tipText}</span>
                        </TipContainer>
                    </>
                ) : null}
            </SelectContainer>
        )
    }

    return (
        <SelectContainer className={`${containerClass} ${field.name}`} style={containerStyle} error={meta.touched && meta.error}>
            <span className="label">{label}</span>

            {screenWidth <= 440 ? (
                <select
                    style={{
                        boxShadow: 'rgba(0, 0, 0, 0.14) 0px 4px 5px 0px, rgba(0, 0, 0, 0.12) 0px 1px 10px 0px, rgba(0, 0, 0, 0.3) 0px 2px 4px -1px',
                        ...style
                    }}
                    className={twMerge('h-11 w-full rounded-[0.25rem] cursor-pointer bg-white', className)}
                    disabled={isDisabled || !options?.length}
                    {...props}
                    {...field}
                    value={field.value?.value}
                    onChange={e => {
                        const selectedOption = options.find(item => item.value == e.target.value)

                        props.onChange?.(selectedOption, props)
                    }}
                >
                    <option value="">Selecione...</option>
                    
                    {options.map(option => (
                        <option value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
            ) : (
                <Select
                    options={options}
                    className={className || ''}
                    noOptionsMessage={() => 'Nenhuma opção disponível'}
                    menuPortalTarget={document.querySelector('body')}
                    components={{
                        Option,
                        IndicatorSeparator: null,
                        DropdownIndicator: null // Chevron 
                    }}
                    styles={selectStyle}
                    style={style}
                    placeholder={placeholder}
                    isDisabled={isDisabled || !options?.length}
                    {...field}
                    {...props}
                />
            )}

            {hint && <div className={`hint ${hint.type}`} dangerouslySetInnerHTML={{ __html: hint.text }} />}

            {tipText ? (
                <>
                    <FiHelpCircle size={14} onMouseEnter={() => handleSpeak(tipAvatarText || tipText)} />

                    <TipContainer>
                        <FaQuestionCircle size={13} />
                        <span>{tipText}</span>
                    </TipContainer>
                </>
            ) : null}

            {meta.touched && meta.error ? (
                <span className="error">{meta.error}</span>
            ) : null}
        </SelectContainer>
    )
}
